module.exports = __webpack_public_path__ + "img/46.270b9e18.png";